import clsx from 'clsx';
import __isEmpty from 'lodash/isEmpty';
import Link from 'next/link';
import { setStorageValue } from '@portal-internet/core';
import { getUrlFriendly } from './RouteResolver';
import styles from './enllac.module.scss';
import { forwardRef } from 'react';

const _getUrl = (props) => {
    const { type, route } = props;
    return getUrlFriendly({ producte: 'web_noticies', ...props, ...route, routePath: route?.type || type });
};

const Enllac = forwardRef((props, ref) => {
    const {
        titol,
        estil,
        className,
        novaFinestra,
        route,
        rel,
        dataTestId,
        ariaLabel,
        title,
        role,
        tabIndex,
        onClick,
        onKeyDown,
        marcatgeAudienciesClick
    } = props;

    const styleLink = clsx({
        [styles[estil]]: !__isEmpty(estil),
        [className]: !__isEmpty(className)
    });

    let href = route?.href || props.href;
    if (__isEmpty(href)) {
        href = _getUrl(props);
    }

    const setStorageClick = () => {
        const dataClickOrigin = {
            name: marcatgeAudienciesClick
        };
        setStorageValue('ccma_click', dataClickOrigin, { path: '/', domain: '.3cat.cat', expires: 1 });
    };

    const handleLinkClick = () => {
        if (onClick) onClick();
        if (marcatgeAudienciesClick) setStorageClick();
    };

    const linkContent = (
        <a
            onClick={handleLinkClick}
            onKeyDown={onKeyDown}
            className={styleLink || null}
            target={novaFinestra ? '_blank' : null}
            rel={novaFinestra ? 'noreferrer' : rel}
            data-testid={dataTestId}
            aria-label={ariaLabel}
            title={title}
            role={role}
            href={href}
            ref={ref}
            tabIndex={tabIndex}
        >
            {titol || props.children}
        </a>
    );
    if (href.startsWith('/3catinfo/')) {
        return (
            <Link href={href} scroll={false}>
                {linkContent}
            </Link>
        );
    } else {
        return linkContent;
    }
});
Enllac.defaultProps = {
    titol: '',
    href: '',
    estil: '',
    disponible: true,
    cleanUrlParams: false,
    novaFinestra: false
};
Enllac.displayName = 'Enllac';
export default Enllac;
